// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de43b7b6","732":"7ec5d38d"}[chunkId] + ".chunk.js";
};